import { BEHAVIOUR_BREATHING, FLAG_ACTIVE } from 'app/views/home/webgl/particlesOptimised/core/ParticleCore';

import type { ParticleCore, PoolRange } from 'app/views/home/webgl/particlesOptimised/core/ParticleCore';

/**
 * Breathe kernel — verbatim port of ParticleProperties._processBreathing()
 * (the icon department's startBreathing scale pulse):
 *
 *   addValue += direction * (changePerTick * deltaTime)
 *   direction flips to -1 above +maxChange, to +1 below -maxChange
 *   targetScale = targetScaleSaved = baseScale + addValue
 *
 * ORDER: the reference runs this inside animatedProps.tick's _setScale,
 * AFTER the scale Inertia tick — so a frame's breathing write is consumed by
 * the NEXT frame's scale ease. The kernel therefore runs after integrate.
 *
 * The targetScaleSaved co-write matters: the repell kernel's outside-radius
 * branch restores tScale from tScaleSaved, which breathing refreshes every
 * frame (reference behaviour, kept).
 */
export function breatheKernel(core: ParticleCore, range: PoolRange, deltaTime: number): void {
	const mask = core.behaviourMask;
	const flags = core.stateFlags;

	for (let i = range.start; i < range.end; i++) {
		if (!(flags[i] & FLAG_ACTIVE) || !(mask[i] & BEHAVIOUR_BREATHING)) {
			continue;
		}

		core.breathAdd[i] += core.breathDir[i] * (core.breathChange[i] * deltaTime);

		if (core.breathAdd[i] > core.breathMax[i]) {
			core.breathDir[i] = -1;
		} else if (core.breathAdd[i] < -1 * core.breathMax[i]) {
			core.breathDir[i] = 1;
		}

		core.tScale[i] = core.tScaleSaved[i] = core.breathBase[i] + core.breathAdd[i];
	}
}
